import React, { useEffect } from "react";
import icon1 from "../../../../assets/ReEngageFollowup/img/ic1.jpg";
import icon2n from "../../../../assets/ReEngageFollowup/img/ic2n.jpg";
import icon3 from "../../../../assets/ReEngageFollowup/img/ic3n.jpg";
import icon2 from "../../../../assets/ReEngageFollowup/img/ic2.jpg";
import icon4 from "../../../../assets/ReEngageFollowup/img/ic4.png";
import icon5 from "../../../../assets/ReEngageFollowup/img/ic5.png";
import icon6 from "../../../../assets/ReEngageFollowup/img/ic6.png";
import s2 from "../../../../assets/ReEngageFollowup/img/s2.png";
import s3 from "../../../../assets/ReEngageFollowup/img/s3.png";
import Car from "../../../../assets/ReEngageFollowup/img/car.png";
import s4 from "../../../../assets/ReEngageFollowup/img/s4.png";
import Header from "./Header";
import Footer from "./Footer";
import AccordSection from "./Accordion";
import "../../../../assets/ReEngageFollowup/scss/modules/custom.scss";
import HeaderTop from "./HeaderTop";

const HP_intro = ({ userDetails, onContinue, pageStatus }) => {
  const maskCardNumber = (cardNumber) => {
    if (!cardNumber) return "XXXX0000";
    const cardStr = cardNumber.toString();
    const lastFourDigits = cardStr.slice(-4).padStart(4, "0");
    return `XXXX${lastFourDigits}`;
  };

  const formatDateOnly = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD format
  };

  const masked_card_num = maskCardNumber(userDetails.card_number);
  const mgrade1 = userDetails.module_grade_1;
  const mgrade2 = userDetails.module_grade_2;
  const mgrade3 = userDetails.module_grade_3;
  const mgrade4_5 = userDetails.final_grade;

  useEffect(() => {
    (async () => {
      const data = {
        uuid: userDetails.uuid,
        page_name: "re_engage_hp_intro",
        status: "visited",
        source: userDetails.followup_data?.atp_sub6,
        re_engaged_id: userDetails.re_engaged_id,
      };
      await pageStatus(data);
    })();
  }, []);

  const slideChange = async (e) => {
    await pageStatus({
      uuid: userDetails.uuid,
      page_name: "re_engage_hp_intro",
      status: "completed",
      source: userDetails.followup_data?.atp_sub6,
      re_engaged_id: userDetails.re_engaged_id,
    });
    onContinue(e);
  };
  return (
    <div className="reengage-followup">
      <HeaderTop userDetails={userDetails} />
      <Header />
      <main className="hero">
        <div className="container">
          <div className="row align-items-center gx-lg-5 pt-2">
            {/* TEXT */}
            <div className="col-lg-7">
              <div className="hero__text">
                <p className="hero__desc">
                  <strong>
                    {" "}
                    {userDetails.user_fullname}, our credit file analysis revealed
                    further potential claims that appear to have merit.
                  </strong>
                </p>
                <table className="table custom-table mt-1 mb-3 ">
                  <tbody>
                    <tr>
                      <td className="data-label">Lender:</td>
                      <td className="data-value">
                        {userDetails.tms_display_name}
                      </td>
                    </tr>
                    <tr>
                      <td className="data-label">Account No:</td>
                      <td className="data-value">{masked_card_num}</td>
                    </tr>
                    <tr>
                      <td className="data-label">Account Opened:</td>
                      <td className="data-value">
                        {formatDateOnly(userDetails.account_startdate)}
                      </td>
                    </tr>
                    <tr>
                      <td className="data-label">Product:</td>
                      <td className="data-value">Vehicle Loan</td>
                    </tr>
                  </tbody>
                </table>
                <div className="custom-bullet-list mb-2">
                  <ul>
                    {mgrade1 == "Yes" && (
                      <li>High/very high utilisation for long periods</li>
                    )}
                    {mgrade2 == "Yes" && (
                      <li>Missed/arrears/default markers</li>
                    )}
                    {mgrade3 == "Yes" && <li>Persistent minimum payments</li>}
                    {mgrade4_5 == "Yes" && (
                      <li>Cash advances / reliance on cash withdrawals</li>
                    )}
                  </ul>
                </div>
                <p className="hero__desc_impo mb-0">
                  Highest Refund: <strong> £21,347</strong>
                  <br />
                  Average Refund: <strong> £4,927*</strong>
                </p>

                {/* DESKTOP CTA */}
                <button
                  onClick={slideChange}
                  value="Instruct TMS to start my claim"
                  className="btn btn-claim btn-lg d-none d-lg-block zoom-in-zoom-out btn-custom"
                >
                  {" "}
                  Instruct TMS to start my claim &gt;{" "}
                </button>
              </div>
            </div>
            {/* IMAGE */}
            <div className="col-lg-5 col-12">
              <div className="hero__art text-center text-lg-end d-none d-lg-block">
                <img
                  src={Car}
                  className="hero__card"
                  alt="credit card illustration"
                />
              </div>
              {/* MOBILE CTA */}
              <div className="text-center mt-3 d-lg-none">
                <button
                  onClick={slideChange}
                  value="Instruct TMS to start my claim"
                  className="btn btn-claim btn-lg w-100 zoom-in-zoom-out"
                >
                  {" "}
                  Instruct TMS to start my claim &gt;
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Why Complete Your Claim */}
      <section className="why-claim">
        <div className="container text-center">
          <h2 className="why-claim__title">Why we reached out</h2>
          <h3 className="why-claim__subtitle">We found one or more of:</h3>
          <div className="why-claim__grid">
            {/* item 1 */}
            <div className="why-claim__item">
              <img src={icon1} className="why-claim__icon" />
              <p className="why-claim__text">
                High/very high utilisation for long periods
              </p>
            </div>
            {/* item 2 */}
            <div className="why-claim__item">
              <img src={icon2n} className="why-claim__icon" alt="Refund" />
              <p className="why-claim__text">Missed/arrears/default markers</p>
            </div>
            {/* item 3 */}
            <div className="why-claim__item">
              <img src={icon3} className="why-claim__icon" alt="Quick" />
              <p className="why-claim__text">Persistent minimum payments</p>
            </div>
            {/* item 4 */}
            <div className="why-claim__item">
              <img src={icon2} className="why-claim__icon" alt="Quick" />
              <p className="why-claim__text">
                Cash advances/reliance on cash withdrawals
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="how-works">
        <div className="container text-center">
          <h2 className="how-works__title">How It Works</h2>
          <div className="row justify-content-center g-4 g-md-5 how-works__row">
            <div className="col-10 col-sm-6 col-md-4">
              <div className="how-works__item">
                <img src={icon4} className="how-works__icon" alt="Pick up" />
                <p className="how-works__text">Pick up where you left off</p>
              </div>
            </div>
            <div className="col-10 col-sm-6 col-md-4">
              <div className="how-works__item">
                <img
                  src={icon5}
                  className="how-works__icon"
                  alt="Short questions"
                />
                <p className="how-works__text">
                  Answer a couple of short questions
                </p>
              </div>
            </div>
            <div className="col-10 col-sm-6 col-md-4">
              <div className="how-works__item">
                <img
                  src={icon6}
                  className="how-works__icon"
                  alt="Eligibility"
                />
                <p className="how-works__text">
                  We’ll check your eligibility instantly
                </p>
              </div>
            </div>
          </div>
          <button
            onClick={slideChange}
            value="Get Started Again"
            className="btn btn-claim how-works__cta"
          >
            Get Started Again <span className="btn-arrow">→</span>
          </button>
        </div>
      </section>
      {/* Trust & Reassurance */}
      <section className="trust py-5">
        <div className="container">
          <h2 className="trust__title text-center mb-4">
            Trust &amp; Reassurance
          </h2>
          {/* row 1: two small cards */}
          <div className="row g-4 mb-2">
            <div className="col-6">
              <figure className="trust-card trust-card--square">
                <img
                  src={s4}
                  alt="Secure process"
                  className="trust-card__img"
                />
              </figure>
              <p className="trust__caption">Secure process backed by TMS</p>
            </div>
            <div className="col-6">
              <figure className="trust-card trust-card--square">
                <img
                  src={s2}
                  alt="No cost to check"
                  className="trust-card__img"
                />
              </figure>
              <p className="trust__caption">No cost to check</p>
            </div>
          </div>
          {/* row 2: big wide card */}
          <div className="row g-4">
            <div className="col-12">
              <figure className="trust-card trust-card--wide mb-2">
                <img
                  src={s3}
                  alt="You're halfway there"
                  className="trust-card__img"
                />
              </figure>
              <p className="trust__caption">You’re already halfway there</p>
            </div>
          </div>
          <div className="text-center mt-4">
            <button
              onClick={slideChange}
              value="Complete My Claim"
              className="btn btn-claim btn-lg trust__cta"
            >
              Complete My Claim <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </section>
      <section className="benefits">
        <div className="container">
          <div className="benefits__grid">
            {/* Item 1 */}
            <div className="benefits__item text-center">
              <div className="benefits__icon">
                <svg
                  width={35}
                  height={35}
                  viewBox="0 0 71 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_330_832"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={71}
                    height={70}
                  >
                    <rect
                      width={71}
                      height={70}
                      transform="matrix(-1 0 0 1 71 0)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_330_832)">
                    <path
                      d="M43.5806 58.9371C49.0315 58.9371 53.7001 57.1122 57.5865 53.4623C61.4729 49.8124 63.416 45.3193 63.416 39.983C63.416 34.6468 61.4729 30.1597 57.5865 26.5217C53.7001 22.8838 49.0315 21.0648 43.5806 21.0648H17.4172L27.7865 10.6955L23.8596 6.76855L6.76868 23.8595L23.8596 40.9504L27.7865 37.0234L17.4172 26.6542H43.5806C47.4694 26.6542 50.8159 27.9321 53.6202 30.488C56.4245 33.0439 57.8267 36.2089 57.8267 39.983C57.8267 43.7571 56.4245 46.9281 53.6202 49.496C50.8159 52.0638 47.4694 53.3477 43.5806 53.3477H16.837V58.9371H43.5806Z"
                      fill="#fff"
                    />
                  </g>
                </svg>
              </div>
              <h3 className="benefits__title">
                Get your Mis-sold Car Finance Fees and Charges Back
              </h3>
              <p className="benefits__desc">
                Many car finances were not sold properly. You could claim back
                the fees and charges plus 8% interest.
              </p>
            </div>
            {/* Item 2 */}
            <div className="benefits__item text-center">
              <div className="benefits__icon">
                <svg
                  width={35}
                  height={35}
                  viewBox="0 0 70 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_330_841"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={70}
                    height={70}
                  >
                    <rect width="69.8652" height="69.8652" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_330_841)">
                    <path
                      d="M26.1993 47.3053C25.1804 47.3053 24.3192 46.9536 23.6157 46.2501C22.9122 45.5466 22.5605 44.6854 22.5605 43.6665C22.5605 42.6476 22.9122 41.7865 23.6157 41.083C24.3192 40.3794 25.1804 40.0277 26.1993 40.0277C27.2182 40.0277 28.0794 40.3794 28.7829 41.083C29.4864 41.7865 29.8381 42.6476 29.8381 43.6665C29.8381 44.6854 29.4864 45.5466 28.7829 46.2501C28.0794 46.9536 27.2182 47.3053 26.1993 47.3053ZM43.6656 47.3053C42.6467 47.3053 41.7856 46.9536 41.0821 46.2501C40.3785 45.5466 40.0268 44.6854 40.0268 43.6665C40.0268 42.6476 40.3785 41.7865 41.0821 41.083C41.7856 40.3794 42.6467 40.0277 43.6656 40.0277C44.6845 40.0277 45.5457 40.3794 46.2492 41.083C46.9527 41.7865 47.3044 42.6476 47.3044 43.6665C47.3044 44.6854 46.9527 45.5466 46.2492 46.2501C45.5457 46.9536 44.6845 47.3053 43.6656 47.3053ZM34.9325 64.0439C41.4338 64.0439 46.9405 61.7878 51.4527 57.2757C55.9648 52.7635 58.2209 47.2568 58.2209 40.7555C58.2209 39.591 58.1481 38.463 58.0025 37.3714C57.857 36.2797 57.5901 35.2245 57.202 34.2056C56.1831 34.4482 55.1643 34.6301 54.1454 34.7514C53.1265 34.8727 52.0591 34.9334 50.9432 34.9334C46.5281 34.9334 42.3556 33.9873 38.4257 32.0951C34.4958 30.2029 31.1481 27.5587 28.3826 24.1625C26.83 27.9468 24.6103 31.2339 21.7236 34.0237C18.8368 36.8134 15.4769 38.9118 11.644 40.3188V40.7555C11.644 47.2568 13.9001 52.7635 18.4122 57.2757C22.9244 61.7878 28.4311 64.0439 34.9325 64.0439ZM29.6308 18.1108C31.8365 22.1789 34.896 25.272 38.8092 27.3899C42.7223 29.5079 46.767 30.5668 50.9432 30.5668C51.7345 30.5668 52.5061 30.5258 53.2581 30.4437C54.0101 30.3616 54.7724 30.2441 55.545 30.091C53.6006 26.2283 50.7838 23.1586 47.0945 20.8819C43.4053 18.6053 39.3513 17.467 34.9325 17.467C33.9546 17.467 33.043 17.5221 32.1977 17.6322C31.3523 17.7423 30.4967 17.9019 29.6308 18.1108ZM12.4613 35.1966C15.197 33.8269 17.7946 31.8255 20.2541 29.1925C22.7136 26.5595 24.3017 23.403 25.0182 19.723C21.8346 21.1674 19.1437 23.2434 16.9455 25.9511C14.7473 28.6588 13.2525 31.7406 12.4613 35.1966ZM9.6063 30.2535C10.8155 27.0289 12.6004 24.1617 14.961 21.6518C17.3216 19.1419 20.0862 17.1891 23.2548 15.7933C22.318 14.6251 21.1705 13.679 19.8121 12.9549C18.4537 12.2309 16.9538 11.8689 15.3124 11.8689C12.4824 11.8689 10.0905 12.8465 8.13673 14.8017C6.18293 16.7569 5.20603 19.1513 5.20603 21.9849C5.20603 23.7082 5.61006 25.283 6.41812 26.7091C7.22613 28.1353 8.28886 29.3167 9.6063 30.2535ZM34.9373 68.4103C31.1124 68.4103 27.5172 67.6844 24.1516 66.2325C20.786 64.7807 17.8584 62.8102 15.3688 60.3213C12.8792 57.8323 10.9082 54.9055 9.45595 51.5408C8.00367 48.1762 7.27754 44.5811 7.27754 40.7555C7.27754 39.6694 7.34192 38.5927 7.47068 37.5254C7.59945 36.458 7.80191 35.4336 8.07807 34.452C5.89852 33.2092 4.14723 31.488 2.82421 29.2883C1.50114 27.0886 0.8396 24.6542 0.8396 21.9849C0.8396 17.958 2.24661 14.5375 5.06062 11.7235C7.87464 8.90945 11.2951 7.50244 15.3221 7.50244C17.8378 7.50244 20.1518 8.0977 22.264 9.28823C24.3763 10.4788 26.0874 12.1004 27.3973 14.153C28.5842 13.8022 29.8133 13.5391 31.0847 13.3637C32.3561 13.1883 33.6387 13.1005 34.9325 13.1005C38.7581 13.1005 42.3532 13.8264 45.7178 15.278C49.0825 16.7297 52.0093 18.6997 54.4983 21.1882C56.9872 23.6767 58.9577 26.603 60.4095 29.9671C61.8614 33.3312 62.5874 36.9257 62.5874 40.7506C62.5874 44.5755 61.8615 48.1707 60.4099 51.5363C58.9583 54.9019 56.9882 57.8295 54.4997 60.3191C52.0112 62.8087 49.0849 64.7797 45.7208 66.232C42.3568 67.6842 38.7623 68.4103 34.9373 68.4103Z"
                      fill="#fff"
                    />
                  </g>
                </svg>
              </div>
              <h3 className="benefits__title">
                Your Claim Fought by Financial &amp; Legal Experts
              </h3>
              <p className="benefits__desc">
                We're ahead of the field, drawing on years of financial services
                and legal expertise for a strong claim
              </p>
            </div>
            {/* Item 3 */}
            <div className="benefits__item text-center">
              <div className="benefits__icon">
                <svg
                  width={35}
                  height={35}
                  viewBox="0 0 70 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_330_852"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={70}
                    height={70}
                  >
                    <rect width="69.8652" height="69.8652" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_330_852)">
                    <path
                      d="M34.9327 62.5314C28.6366 60.8147 23.4238 57.1087 19.2942 51.4136C15.1646 45.7183 13.0999 39.3513 13.0999 32.3126V15.5629L34.9327 7.38965L56.7655 15.5629V32.0552C56.0862 31.779 55.3734 31.5299 54.627 31.3079C53.8806 31.0858 53.1379 30.9113 52.399 30.7844V18.6027L34.9327 12.0808L17.4664 18.6027V32.3126C17.4664 34.8915 17.8302 37.4098 18.558 39.8674C19.2858 42.325 20.2888 44.6222 21.5671 46.7588C22.8453 48.8955 24.3727 50.8138 26.1492 52.5137C27.9257 54.2137 29.8534 55.5712 31.9322 56.5863L32.0162 56.5584C32.4006 57.6257 32.8988 58.6483 33.5108 59.6261C34.1229 60.6038 34.8189 61.4921 35.5989 62.2907C35.4757 62.3281 35.3647 62.3682 35.2658 62.4111C35.1669 62.454 35.0559 62.4941 34.9327 62.5314ZM49.4879 62.5875C45.8529 62.5875 42.7609 61.313 40.2118 58.764C37.6628 56.2149 36.3883 53.1229 36.3883 49.4878C36.3883 45.8528 37.6628 42.7607 40.2118 40.2117C42.7609 37.6627 45.8529 36.3882 49.4879 36.3882C53.123 36.3882 56.215 37.6627 58.7641 40.2117C61.3131 42.7607 62.5876 45.8528 62.5876 49.4878C62.5876 53.1229 61.3131 56.2149 58.7641 58.764C56.215 61.313 53.123 62.5875 49.4879 62.5875ZM48.2004 57.4931H50.7755V50.7754H57.4933V48.2003H50.7755V41.4825H48.2004V48.2003H41.4826V50.7754H48.2004V57.4931Z"
                      fill="#fff"
                    />
                  </g>
                </svg>
              </div>
              <h3 className="benefits__title">
                Respecting Your Information Security
              </h3>
              <p className="benefits__desc">
                We take security very seriously and follow the rules of the Data
                Protection Act
              </p>
            </div>
          </div>
        </div>
      </section>
      <AccordSection />
      <Footer />
    </div>
  );
};

export default HP_intro;
